module.exports = __webpack_public_path__ + "static/media/tax.128e4b23.svg";